{
  "addMoreText": "You can add multiple phone numbers to your account.",
  "addPhoneNumberHelpBodyText": "You can add phone numbers to your account. Doing so allows you to receive SMS alerts from your devices on these phone numbers.\n\nSMS alerts can be enabled or disabled for a phone number, and also for an individual device.\n\nFarmHQ will notify you about certain events and activities by default. You can also create custom notifications in the Device Notifications screen in the device profile.",
  "addPhoneNumberHelpTitle": "Adding Phone Numbers",
  "addPhoneNumberHelperText": "Number from another country? Change the country selection, or type + followed by the full international number.",
  "addPhoneNumberInputLabel": "Phone Number",
  "addPhoneNumberInputPlaceholder": "e.g. 222 333 4444",
  "countrySelectLabel": "Country",
  "addPhoneNumberInvalidNumber": "Invalid phone number. Please check the input.",
  "addPhoneNumberLink": "Add Phone Number",
  "addPhoneNumberTitle": "Add Phone Number",
  "deletePhoneNumber": "Delete this phone number?",
  "initialPhoneNumberPrompt": "Add your phone number to receive notifications about your equipment.",
  "linkTo": "Phone Numbers",
  "listEmptyMessage": "You do not have any phone numbers added to your account. Add one to enable SMS alerts from your devices.",
  "messageSent": "Message sent.",
  "codeSent": "Code sent",
  "phoneNumberNotFound": "Phone number not found.",
  "phoneNumbersHelpBody": "Phone numbers are used to send SMS alerts to you about your devices' activity. You can add multiple phone numbers to your account, and enable or disable SMS alerts for each number.\n\nYou can also enable or disable SMS alerts for individual devices in the device profile.",
  "phoneNumbersHelpTitle": "About Phone Numbers",
  "skipForNow": "Skip for now",
  "sendTestSmsBtn": "Send Test SMS",
  "title": "Phone Numbers",
  "tooManyPhoneNumbersMessage": "You have reached your account's limit for phone numbers. Delete and existing phone number to add a new one.",
  "tooManyPhoneNumbersTitle": "Forbidden",
  "verifyButton": "Verify",
  "verifyHelpBodyText": "When you add a phone number to your account, FarmHQ will send a verification code to that number. Enter the code in the field provided to verify the number.\n\nYou can only receive notifications on verified phone numbers.",
  "verifyHelpTitle": "Verifying Phone Numbers",
  "verifyInstructions": "Enter the code sent to your mobile device:",
  "verifyResendCodeHint": "Didn't get a code?",
  "verifySuccessMessage": "Your phone number has been verified successfully. You can now receive notifications about your devices' activity.",
  "verifySuccessToast": "Phone number verified successfully.",
  "verifyTitle": "Verify Phone Number",
  "youCanAddYourPhoneNumberLater": "Note: You can add your phone number later using the account settings menu."
}
